module.exports = __webpack_public_path__ + "static/media/licenca-dragan.1a501e3d.pdf";